export const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

export const setHorizontalBlur = (
  blurNode: SVGFEGaussianBlurElement | null,
  amount: number
) => {
  blurNode?.setAttribute('stdDeviation', `${amount.toFixed(2)},0`);
};
